<template>
  <div class="echarts1" ref="echarts1">

  </div>
</template>

<script>

import {FontChart} from "@/utils/utils";
import $ from "jquery";
import Axios from "@/utils/Axios";
import qs from "qs";
import Bus from "@/utils/bus.js";
export default {
  name: 'echarts1',
  components: {},
  props: {
    active: {
      type:  Number,
      default() {
        return '';
      }
    },


  },
  data() {
    return {
      alldata:"",
      depid:null,
    }
  },
  mounted() {
    let that=this
    this.depid= Number(localStorage.getItem("deptId"));
this.getpowdata()
    Bus.$on('changeid',(val)=>{
      this.depid=val.deptId
      that.getpowdata()
    })
  },
  methods: {
    drawLine() {
      window.addEventListener('resize', this.drawLine)
      let myChart = this.$echarts.init(this.$refs.echarts1)
      let value = this.alldata
      let int = value.toFixed(2).split('.')[0]
      var option = {
        title: [
          {
            text: '{a|' + int + '}',
            x: 'center',
            y: '40%',
            textStyle: {
              rich: {
                a: {
                  fontSize:FontChart(28),
                  color: '#DDEDFF'
                }
              }
            }
          },
          {
            text: '{a|异常总数}',
            x: 'center',
            y: '52%',
            textStyle: {
              rich: {
                a: {
                  fontSize:FontChart(16),
                  color: '#DDEDFF'
                }
              }
            }
          },
        ],
        series: [
          {
            type: 'gauge',
            radius: '75%',
            clockwise: true,
            startAngle: '90',
            endAngle: '-269.9999',
            splitNumber: 25,
            detail: {
              offsetCenter: [0, -10],
              formatter: ' '
            },
            pointer: {
              show: true
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: [
                  [0, '#fed747'],
                  [52 / 100, '#070d5d'],
                  [1, '#fed747']
                ],
                width: 15
              }
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: true,
              length: 30,
              lineStyle: {
                color: '#070e5e',
                width: 2
              }
            },
            axisLabel: {
              show: false
            }
          },
          {
            type: 'pie',
            name: '饼状背景渐变背景',
            radius: ['0%', '45%'],
            center: ['50%', '50%'],
            startAngle: 110,
            hoverAnimation: false,
            itemStyle: {
              normal: {
                color: new this.$echarts.graphic.RadialGradient(.5, .5, 0.5, [{
                  offset: 0,
                  color: '#1c2762'
                },
                  {
                    offset: 0.5,
                    color: '#1a2763'
                  }, {
                    offset: 0.8,
                    color: '#525460'
                  },
                  {
                    offset: 1,
                    color: '#938a6d'
                  }
                ], false),
              }
            },
            tooltip: {
              show: false,
            },
            label: {
              show: false
            },
            data: [50]
          },
          {
            center: ['50%', '50%'],
            type: 'gauge',
            startAngle: 270,
            endAngle: -89.9999,
            axisTick: {
              show: false,
              length: FontChart(5),
            },
            axisLabel: {
              show: false,
            },
            radius: '85%',
            splitNumber: FontChart(28),
            axisLine: {
              show: false,
              lineStyle: {
                color: '#fcd84f',
                width: FontChart(0),
              },
            },
            splitLine: {
              length: FontChart(15),
              lineStyle: {
                width: FontChart(6),
                color: '#fed747',
              },
            },
            detail: {
              show: false,
            },
          },
          {
            center: ['50%', '50%'],
            type: 'gauge',
            startAngle: 270,
            endAngle: -89.9999,
            axisTick: {
              show: false,
              length: FontChart(5),
            },
            axisLabel: {
              show: false,
            },
            radius: '95%',
            splitNumber: FontChart(45),
            axisLine: {
              show: false,
              lineStyle: {
                color: '#fcd84f',
                width: FontChart(0),
              },
            },
            splitLine: {
              length: FontChart(1),
              lineStyle: {
                width: FontChart(4),
                color: '#fed747',
              },
            },
            detail: {
              show: false,
            },
          },
        ]
      }
      myChart.clear()
      myChart.resize()
      myChart.setOption(option)
    },
    getpowdata(){
      let that = this;
      let param = {};
      param.method="post";
      param.url="/portal/eventSortStatis"

      param.data=qs.stringify({
        day:this.active,
        deptId:this.depid
      })
      Axios.ajax(param).then((res)=>{
        if(res.resultCode=='0'){
          this.powerdata=res.data

          let daat=0
          for(let i=0;i<res.data.length;i++){
            daat+=res.data[i].count
          }
          this.alldata=daat
          this.drawLine()
        }else{

        }

      })
    },
  },
  watch: {
    active() {
      this.getpowdata()

    },
    depid() {
      this.getpowdata()

    },
  },
}
</script>

<style lang="scss" scoped>
.echarts1 {
  position: relative;
  width: calc(100% - 0px);
  height: calc(100% - 0px);
}
</style>
